import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgIf } from '@angular/common';
import { ModalComponent } from '../../common/components/modal/modal.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

export interface IConfirmDialog {
  title: string;
  subTitle: string;
  subject?: string;
  confirmButtonText: string;
  closeButtonText?: string;
}

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  standalone: true,
  imports: [ModalComponent, NgIf, FaIconComponent]
})
export class ConfirmComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<ConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IConfirmDialog
  ) {}

  ngOnInit() {}

  confirm() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close();
  }
}
